export const mapObject = (array, mapKey, mapValue = (i) => i) =>
  Object.fromEntries(array.map((el, i, arr) => [mapKey(el, i, arr), mapValue(el, i, arr)]));

export const subtractDateRanges = (
  arrayA,
  arrayB,
  extraCondition = () => false,
  startFieldName = "startDate",
  endFieldName = "endDate"
) => {
  // Validate inputs
  if (!Array.isArray(arrayA) || !Array.isArray(arrayB)) {
    throw new Error("Both inputs must be arrays");
  }

  // Convert date strings to Date objects for easier comparison
  const processedArrayA = arrayA.map((item) => ({
    ...item,
    [startFieldName]: new Date(item[startFieldName]),
    [endFieldName]: new Date(item[endFieldName]),
  }));

  const processedArrayB = arrayB.map((item) => ({
    ...item,
    [startFieldName]: new Date(item[startFieldName]),
    [endFieldName]: new Date(item[endFieldName]),
  }));

  // Sort arrayB by startDate for efficient processing
  processedArrayB.sort((a, b) => a[startFieldName] - b[startFieldName]);

  let result = [...processedArrayA];

  // For each range in arrayB, subtract it from all ranges in our result
  for (let index = 0; index < processedArrayB.length; index += 1) {
    const rangeB = processedArrayB[index];
    const newResult = [];

    for (let index2 = 0; index2 < result.length; index2 += 1) {
      const rangeA = result[index2];
      // No overlap case - keep range as is

      if (!!extraCondition && !extraCondition(rangeA, rangeB)) {
        newResult.push(rangeA);
        // eslint-disable-next-line no-continue
        continue;
      }

      if (
        rangeB[startFieldName] >= rangeA[endFieldName] ||
        rangeB[endFieldName] <= rangeA[startFieldName]
      ) {
        newResult.push(rangeA);
        // eslint-disable-next-line no-continue
        continue;
      }

      // Handle different types of overlap

      // Case 1: Left portion remains (B overlaps right side of A)
      if (rangeB[startFieldName] > rangeA[startFieldName]) {
        newResult.push({
          ...rangeA,
          [startFieldName]: rangeA[startFieldName],
          [endFieldName]: new Date(
            Math.min(rangeA[endFieldName].getTime(), rangeB[startFieldName].getTime())
          ),
        });
      }

      // Case 2: Right portion remains (B overlaps left side of A)
      if (rangeB[endFieldName] < rangeA[endFieldName]) {
        newResult.push({
          ...rangeA,
          [startFieldName]: new Date(
            Math.max(rangeA[startFieldName].getTime(), rangeB[endFieldName].getTime())
          ),
          [endFieldName]: rangeA[endFieldName],
        });
      }

      // Note: If rangeB completely contains rangeA, nothing is added (deletion case)
    }

    result = newResult;
  }

  // Convert dates back to ISO strings
  return result.map((item) => ({
    ...item,
    [startFieldName]: item[startFieldName].toISOString(),
    [endFieldName]: item[endFieldName].toISOString(),
  }));
};
